
export const CHECKOUT_URL = "https://aromaticos.impultienda.ar/checkout/sales";
export const PIXEL_ID = "4622525324645553";
